import request from "@/utils/request";

// 文件上传接口
export function uploadFile(data) {
  return request({
    url: "/file/upload",
    method: "post",
    data,
  });
}

// 文件上传接口（新，包含上传人，上传时间）
export function uploadFileMultipleNew(data) {
  return request({
    url: "/file/upload",
    method: "post",
    data,
  });
}

// 批量上传
export function uploadFileMultiple(data) {
  return request({
    url: "/file/upload",
    method: "post",
    data,
  });
}

// 文件预览
export function previewFile(data) {
  return request({
    url: "/atom/file/preview",
    method: "post",
    data,
  });
}
